import type { JSX } from "react";

import { Route, Routes } from "react-router-dom";
import ApiCosts from "./ApiCosts";

function ApiCostRoutes(): JSX.Element {
    return (
        <Routes>
            <Route index element={<ApiCosts />} />
        </Routes>
    );
}

export default ApiCostRoutes;
